import PropTypes from "prop-types";

export const positionShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  color_hex: PropTypes.string,
  volunteer: PropTypes.bool.isRequired,
  default_hourly_rate: PropTypes.string,
  staff_department_id: PropTypes.number.isRequired,
  position: PropTypes.number,
  archived: PropTypes.bool.isRequired,
  staff_count: PropTypes.number.isRequired,
  template_count: PropTypes.number.isRequired,
});

export const departmentShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  color_hex: PropTypes.string,
  position: PropTypes.number,
  archived: PropTypes.bool.isRequired,
  general: PropTypes.bool.isRequired,
  positions: PropTypes.arrayOf(positionShape).isRequired,
  leads: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      staff_member_id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
  lead_candidates: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
});
